module.exports = "/_next/static/images/nebo-card-6c5e84b20a301e175769253e6ee275ab.png";